<template>
  <v-app id="app">
    <mySidebar />

    <v-content>
      <myHeader />

      <v-container fill-height>
        <v-layout>
          <v-flex>
            <v-alert
              class="mb-3 py-2"
              transition="scale-transition"
              dismissible
              v-model="alert"
              :color="this.$store.getters['master/alert'].type"
              :type="this.$store.getters['master/alert'].type"
              outlined
            >
              <v-layout align-center wrap>
                <div>{{ this.$store.getters["master/alert"].message }}&nbsp;</div>

                <!-- PERSON EMAIL ALREADY EXIST -->
                <router-link
                  small
                  color="error"
                  v-if="this.$store.getters['master/alert'].code == 413"
                  :to="{
                    path: BACKEND_URL + '/persons/view/' + this.$store.getters['master/alert'].extras.userid
                  }"
                  >{{ $t("global.click_here_create_user_link") }}</router-link
                >
              </v-layout>
            </v-alert>

            <router-view />
          </v-flex>
        </v-layout>
      </v-container>

      <notificationBar />
    </v-content>
  </v-app>
</template>

<script>
import myHeader from "../../themes/partials/Header.vue"
import mySidebar from "../../themes/partials/Sidebar.vue"
import notificationBar from "@/modules/notifications/partials/NotificationBar.vue"

export default {
  name: "main-layout",

  components: {
    myHeader,
    mySidebar,
    notificationBar
  },

  computed: {
    alert: {
      get() {
        return this.$store.getters["master/alert"].show
      },
      set() {
        this.$globalMessages("", "", false)
        return false
      }
    }
  }
}
</script>
